'use client';
import { forwardRef } from 'react';

import { styled } from 'styled-system/jsx';
import { skeleton, type SkeletonVariantProps } from 'styled-system/recipes';
import type { JsxStyleProps } from 'styled-system/types';

import { ark } from '@ark-ui/react/factory';

import type { Assign, HTMLArkProps } from '@ark-ui/react';

const StyledSkeleton = styled(ark.div, skeleton);

export interface SkeletonProps
  extends Assign<JsxStyleProps, HTMLArkProps<'div'>>, SkeletonVariantProps {
  /**
   *
   * @default false
   */
  isLoaded?: boolean;
}

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>((props, ref) => {
  const { isLoaded, ...otherProps } = props;

  if (isLoaded) {
    return <styled.div animation='fade-in' ref={ref} {...otherProps} />;
  }
  return <StyledSkeleton ref={ref} {...otherProps} />;
});

Skeleton.displayName = 'Skeleton';
